import { Helmet } from 'react-helmet';

import { useSiteMetadata } from '../utils/useSiteMetaData';

export interface SeoProps {
  title: string;
  description?: string;
  lang?: string;
  meta?: any;
}

export const Seo = (
  {
    title,
    description,
    lang = 'en',
    meta = [],
  }: SeoProps,
) => {
  const { description: metaDescription, author } = useSiteMetadata();

  const desc = description || metaDescription;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      titleTemplate={title}
      meta={[
        {
          name: 'description',
          content: desc,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: desc,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:card',
          content: 'summary',
        },
        {
          name: 'twitter:creator',
          content: author || '',
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: desc,
        },
      ].concat(meta)}
    />
  )
}
